<template>
  <div :class="rootClasses">
    <SfButton
      :class="buttonClasses"
      @click.stop.prevent="handlePleatAction"
      @keydown.enter.stop.prevent="handlePleatAction"
    >
      <div class="engraving-pleat__wrapper">
        <VaimoIcon
          v-if="icon"
          :icon="icon"
          :size="iconSize"
          class="engraving-pleat__icon"
          :label="icon"
        />

        <div class="engraving-pleat__text">
          <h5 class="engraving-pleat__heading">
            {{ heading }}
          </h5>
          <p
            v-if="isDefault"
            class="engraving-pleat__description"
            :class="{ 'mt-2xs': description }"
          >
            {{ description }}
          </p>
        </div>

        <VaimoIcon
          v-if="isDefault"
          icon="pairing"
          class="engraving-pleat__icon-secondary"
          label="pairing"
        />
      </div>
    </SfButton>
  </div>
</template>

<script>
import { computed, defineComponent } from '@nuxtjs/composition-api';
import { SfButton } from '@storefront-ui/vue';

export default defineComponent({
  name: 'EngravingPleat',
  components: {
    SfButton,
    VaimoIcon: () => import('@/components/atoms/VaimoIcon.vue')
  },
  props: {
    heading: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: 'pen'
    },
    iconSize: {
      type: Number,
      default: 24
    },
    variant: {
      type: String,
      default: 'default',
      validator: (value) => ['default', 'lite', 'compact'].includes(value)
    },
    fullWidth: {
      type: Boolean,
      default: false
    }
  },
  emits: ['pleat:click'],
  setup(props, { emit }) {
    const rootClasses = computed(() => [
      'engraving-pleat',
      `engraving-pleat--${props.variant}`
    ]);

    const buttonClasses = computed(() => [
      'engraving-pleat__button',
      { 'w-full': props.fullWidth },
      `engraving-pleat__button--${props.variant}`
    ]);

    const handlePleatAction = () => {
      emit('pleat:click');
    };

    const isDefault = computed(() => props.variant === 'default');

    return {
      rootClasses,
      buttonClasses,
      handlePleatAction,
      isDefault
    };
  }
});
</script>

<style lang="scss" scoped>
@import './EngravingPleat';
</style>
